angular.module('autoremind.templates')
    .directive('templateAr2Upload', ['Upload', 'logger', 'templateService', '$interval', 'dialogs', '$timeout', 'templateAr2Service',
    function (Upload, logger, templateService, $interval, dialogs, $timeout, templateAr2Service) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/templates/templates-ar2-upload.html',
            link: function (scope, elem, attr) {
                scope.templateAr2Service = templateAr2Service;
                scope.viewModel = {
                    loadingIndicator: {
                        refCount: 0,
                        state: false
                    },
                    defaultLang: 'us-en',
                    formModel: {
                        assignToUser: false,
                        uploadToDefFolder: false,
                        uploadedFile: null,
                        filePath: {
                            prefix: '',
                            fileName: ''
                        },
                        file: angular.isDefined(scope.template.file) ? scope.template.file : '',
                        displayName: angular.isDefined(scope.template.displayName) ? scope.template.displayName : '',
                        templateName: angular.isDefined(scope.template.templateName) ? scope.template.templateName : '',
                        languageId: 0,
                        type: angular.isDefined(scope.template.type) ? scope.template.type : 'email'
                    },
                    isUserCustomTemplate: !!(scope.isCustomTemplate),
                    uploadingModel: {
                        fileLoadProgress: 0,
                        isFileUploading: false,
                        isFileUloaded: false,
                        isUploadError: false
                    },
                    isUploadForm: angular.isDefined(scope.template.templateId) ? true : false,
                    tmpFile: null,
                    prevFileName: '',
                    isError: false,
                    errorMessage: '',
                    error: null,
                    uploadErrors: {
                        language: null,
                        type: null
                    },
                    pathandtemplatename: {
                        pathExist: false,
                        templateNameExist: false,
                        pathMessage: '',
                        templateNameMessage: ''
                    }
                };
                scope.init = function () {
                    scope.templateAr2Service.getDefaultFolderName();
                }();
                scope.templateAr2Service.getLanguages()
                    .then(function () {
                    if (angular.isDefined(scope.template.language)) {
                        scope.getLanguageIdByLanguage(scope.template.language);
                        scope.createFileName();
                    }
                    else {
                        //default language
                        scope.getLanguageIdByLanguage(scope.viewModel.defaultLang);
                    }
                });
                scope.getLanguageIdByLanguage = function (language) {
                    for (var i in scope.templateAr2Service.languages) {
                        if (scope.templateAr2Service.languages[i].languageName === language) {
                            scope.viewModel.formModel.languageId = scope.templateAr2Service.languages[i].languageId;
                            return;
                        }
                    }
                };
                scope.onFileSelect = function ($files) {
                    if (!scope.viewModel.isUploadForm) {
                        scope.clearUploadingModel();
                    }
                    var alias = scope.viewModel.formModel.uploadedFile ? scope.viewModel.formModel.uploadedFile.alias : new Date().getTime() + '.tmp';
                    scope.viewModel.formModel.uploadedFile = angular.isDefined($files[0]) ? $files[0] : $files;
                    scope.viewModel.uploadingModel.isFileUploading = true;
                    if (!scope.viewModel.isUploadForm) {
                        scope.createFileName();
                    }
                    scope.viewModel.formModel.uploadedFile.alias = alias;
                    scope.viewModel.isError = false;
                    templateAr2Service.uploadTemplateFile(scope.viewModel.formModel.uploadedFile)
                        .progress(function (evt) {
                        scope.viewModel.uploadingModel.fileLoadProgress = parseInt(100.0 * evt.loaded / evt.total);
                    }).success(function (response, status, headers, config) {
                        scope.parseLoadedFile();
                        scope.createFileName();
                    }).error(function (err) {
                        console.log('err', err);
                        scope.viewModel.isError = true;
                        scope.viewModel.errorMessage = 'Error uploading the file!';
                        scope.viewModel.error = err.error.reason;
                    });
                };
                scope.parseLoadedFile = function () {
                    templateAr2Service.parseTemplate(scope.viewModel.formModel.uploadedFile.alias)
                        .then(function (data) {
                        if (!angular.isDefined(data.templateVariables)) {
                            return;
                        }
                        if (!scope.viewModel.isUploadForm || scope.isCustomTemplate) {
                            scope.viewModel.formModel.type = (angular.isDefined(data.templateVariables.templateType)) ? data.templateVariables.templateType : '';
                        }
                        if (scope.viewModel.isUploadForm) {
                            scope.checkMatchFileWithTemplate(data.templateVariables);
                            return;
                        }
                        scope.checkpathandtemplatename();
                        scope.viewModel.formModel.templateName = (angular.isDefined(data.templateVariables.templateName)) ? data.templateVariables.templateName : '';
                        scope.viewModel.formModel.displayName = (angular.isDefined(data.templateVariables.displayName)) ? data.templateVariables.displayName : '';
                        if (angular.isDefined(data.templateVariables.templateLanguage) && data.templateVariables.templateLanguage !== '') {
                            for (var i in scope.templateAr2Service.languages) {
                                if (scope.templateAr2Service.languages[i].languageName === data.templateVariables.templateLanguage) {
                                    scope.viewModel.formModel.languageId = scope.templateAr2Service.languages[i].languageId;
                                    break;
                                }
                            }
                        }
                    }, function (err) {
                        scope.viewModel.isError = true;
                        scope.viewModel.errorMessage = 'Error of parsing the file!';
                        scope.viewModel.error = err.error.reason;
                    });
                };
                scope.checkpathandtemplatename = function () {
                    if (!scope.viewModel.formModel.uploadedFile ||
                        (scope.viewModel.isUploadForm && !scope.isCustomTemplate)) {
                        return;
                    }
                    var requestData = {
                        templateName: scope.viewModel.formModel.templateName,
                        type: scope.viewModel.formModel.type,
                        language: scope.viewModel.formModel.languageId,
                        fileName: scope.viewModel.formModel.file
                    };
                    if (scope.viewModel.isUserCustomTemplate || scope.viewModel.formModel.uploadToDefFolder) {
                        requestData.fileName = scope.viewModel.formModel.filePath.prefix + scope.viewModel.formModel.filePath.fileName;
                    }
                    scope.templateAr2Service.checkpathandtemplatename(requestData, scope.viewModel.loadingIndicator)
                        .then(function (res) {
                        scope.viewModel.pathandtemplatename.pathExist = res.pathExist;
                        scope.viewModel.pathandtemplatename.templateNameExist = res.templateNameExist;
                        if (res.pathExist) {
                            scope.viewModel.pathandtemplatename.pathMessage = 'This exact path is already registered at least once. Replacing not allowed!';
                        }
                        if (res.templateNameExist) {
                            var languageName = '';
                            for (var i in scope.templateAr2Service.languages) {
                                if (scope.templateAr2Service.languages[i].languageId === requestData.language) {
                                    languageName = scope.templateAr2Service.languages[i].languageName;
                                    break;
                                }
                            }
                            scope.viewModel.pathandtemplatename.templateNameMessage = '\'' + scope.viewModel.formModel.type + ' | ' + languageName + ' | ' + scope.viewModel.formModel.templateName + '\' is already exist. Please change the template name.';
                        }
                    }, function (err) {
                    });
                };
                var _timeout = null;
                scope.templateNameIsChanged = function () {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                    }
                    _timeout = $timeout(function () {
                        _timeout = null;
                        scope.checkpathandtemplatename();
                    }, 1000);
                };
                scope.checkMatchFileWithTemplate = function (templateVariables) {
                    if (angular.isDefined(templateVariables.templateType) && scope.template.type !== templateVariables.templateType) {
                        scope.viewModel.uploadErrors.type = 'Template type in uploaded file isn\'t mismatched with current template';
                    }
                    else {
                        scope.viewModel.uploadErrors.type = null;
                    }
                    if (angular.isDefined(templateVariables.templateLanguage) && scope.template.language !== templateVariables.templateLanguage) {
                        scope.viewModel.uploadErrors.language = 'Template language in uploaded file isn\'t mismatched with current template';
                    }
                    else {
                        scope.viewModel.uploadErrors.language = null;
                    }
                };
                scope.getPrefixForFileName = function () {
                    var type = angular.copy(scope.viewModel.formModel.type);
                    var language = 'default';
                    for (var i in templateAr2Service.languages) {
                        if (templateAr2Service.languages[i].languageId === scope.viewModel.formModel.languageId) {
                            language = templateAr2Service.languages[i].languageName;
                            language = language.replace('-', '');
                            break;
                        }
                    }
                    return language + '-' + type + '-';
                };
                scope.createFileNameForCustomTemplate = function (isNoNeedRenameFileName) {
                    var prefix = scope.getPrefixForFileName();
                    var fileName = '';
                    var userFolder = '';
                    if (angular.isDefined(templateService.model.currentUser)) {
                        userFolder = templateService.model.currentUser + '/';
                    }
                    if (scope.viewModel.formModel.uploadedFile) {
                        fileName = angular.copy(scope.viewModel.formModel.uploadedFile.name);
                        fileName = fileName.toLowerCase();
                        fileName = fileName.replace(/\s{1,}/g, "-");
                    }
                    scope.viewModel.formModel.filePath.prefix = userFolder + prefix;
                    if (!isNoNeedRenameFileName) {
                        scope.viewModel.formModel.filePath.fileName = fileName;
                    }
                };
                scope.createFileNameForDefaultTemplate = function () {
                    var fileName = '';
                    var prefix = scope.getPrefixForFileName();
                    if (scope.viewModel.formModel.uploadedFile) {
                        fileName = angular.copy(scope.viewModel.formModel.uploadedFile.name);
                        fileName = fileName.toLowerCase();
                        fileName = fileName.replace(/\s{1,}/g, "-");
                    }
                    scope.viewModel.formModel.file = prefix + fileName;
                    scope.viewModel.formModel.filePath.fileName = fileName;
                    // scope.viewModel.formModel.file = (angular.isDefined(scope.viewModel.formModel.file) ) ? scope.viewModel.formModel.file.replace(scope.viewModel.prevFileName, '') : '';
                    // if (scope.viewModel.formModel.file.lastIndexOf('/') +1 !== scope.viewModel.formModel.file.length) {
                    //     scope.viewModel.formModel.file += '/';
                    // }
                    // var tmpFileName = angular.copy(scope.viewModel.formModel.uploadedFile.name);
                    // var fileName = '';
                    // if (scope.viewModel.formModel.uploadedFile) {
                    //     fileName += scope.viewModel.formModel.uploadedFile.name;
                    // }
                    // fileName = fileName.toLowerCase();
                    // fileName = fileName.replace(/\s{1,}/g, "-");
                    // scope.viewModel.formModel.file += fileName
                    // scope.viewModel.prevFileName = fileName;
                    // console.log('createFileName', tmpFileName, '-----', fileName);
                };
                scope.createFileName = function (isNoNeedRenameFileName) {
                    if (scope.viewModel.isUploadForm && !scope.isCustomTemplate) {
                        return;
                    }
                    if (!scope.viewModel.isUserCustomTemplate && !scope.isCustomTemplate) {
                        scope.createFileNameForDefaultTemplate();
                        return;
                    }
                    scope.createFileNameForCustomTemplate(isNoNeedRenameFileName);
                };
                scope.$watch('viewModel.isUserCustomTemplate', function () {
                    scope.createFileName();
                    scope.checkpathandtemplatename();
                });
                scope.$watch('viewModel.formModel.type', function () {
                    scope.createFileName(true);
                    scope.checkpathandtemplatename();
                });
                scope.$watch('viewModel.formModel.languageId', function () {
                    scope.createFileName(true);
                    scope.checkpathandtemplatename();
                });
                String.prototype.replaceAt = function (index, character) {
                    return this.substr(0, index) + character + this.substr(index + 1);
                };
                scope.setUserCustomTemplate = function () {
                    scope.viewModel.formModel.uploadToDefFolder = false;
                    console.log(scope.viewModel.isUserCustomTemplate, templateService.model.currentUser);
                    if (scope.viewModel.isUserCustomTemplate && templateService.model.currentUser) {
                        scope.viewModel.formModel.file = templateService.model.currentUser + '/' + scope.viewModel.formModel.file;
                    }
                    if (!scope.viewModel.isUserCustomTemplate && templateService.model.currentUser) {
                        scope.viewModel.formModel.file = scope.viewModel.formModel.file.replace(templateService.model.currentUser, "");
                    }
                    scope.viewModel.formModel.file = scope.viewModel.formModel.file.replace(/\/{2,}/g, "/");
                    if (scope.viewModel.formModel.file.indexOf('/') === 0) {
                        scope.viewModel.formModel.file = scope.viewModel.formModel.file.substr(1);
                    }
                };
                scope.setPathToDefault = function () {
                    scope.viewModel.isUserCustomTemplate = false;
                    scope.viewModel.formModel.assignToUser = false;
                    var prefix = scope.getPrefixForFileName();
                    scope.viewModel.formModel.filePath.prefix = scope.templateAr2Service.templateDefaultfolder + prefix;
                    scope.checkpathandtemplatename();
                };
                if (scope.templateAr2Service.userModel.userId && (!scope.viewModel.isUploadForm || scope.isCustomTemplate)) {
                    scope.viewModel.isUserCustomTemplate = true;
                    scope.viewModel.formModel.assignToUser = true;
                    scope.setUserCustomTemplate();
                }
                scope.isCanBeRegistered = function () {
                    if (!scope.viewModel.formModel.uploadedFile) {
                        return false;
                    }
                    if (scope.viewModel.formModel.file.length < 1) {
                        return false;
                    }
                    if (scope.viewModel.formModel.templateName.length < 1 && scope.viewModel.isUserCustomTemplate) {
                        return false;
                    }
                    if (scope.viewModel.formModel.displayName.length < 1) {
                        return false;
                    }
                    if (scope.viewModel.isUploadForm && (scope.viewModel.uploadErrors.language || scope.viewModel.uploadErrors.type)) {
                        return false;
                    }
                    if (scope.viewModel.pathandtemplatename.pathExist || scope.viewModel.pathandtemplatename.templateNameExist) {
                        return false;
                    }
                    return true;
                };
                scope.getPrefixForFilename = function (langName, type) {
                    langName = langName.replace('-', '');
                    return '/' + langName + '-' + type + '-';
                };
                scope.replaceTemplate = function () {
                    var dataToRequest = {
                        tmpFileName: scope.viewModel.formModel.uploadedFile.alias,
                        fileName: scope.viewModel.formModel.file
                    };
                    scope.templateAr2Service.replaceTemplate(dataToRequest)
                        .then(function (res) {
                        scope.success();
                    }, function (err) {
                    });
                };
                scope.registerTemplate = function () {
                    var templateData = angular.copy(scope.viewModel.formModel);
                    templateData.tmpFileName = scope.viewModel.formModel.uploadedFile.alias;
                    for (var i in scope.templateAr2Service.languages) {
                        if (scope.templateAr2Service.languages[i].languageId === templateData.languageId) {
                            templateData.languageName = scope.templateAr2Service.languages[i].languageName;
                            break;
                        }
                    }
                    delete templateData.uploadedFile;
                    // templateData.file = templateData.file.replaceAt(templateData.file.lastIndexOf('/'), scope.getPrefixForFilename(templateData.languageName, templateData.type));
                    if (scope.viewModel.isUserCustomTemplate || scope.viewModel.formModel.uploadToDefFolder) {
                        templateData.file = scope.viewModel.formModel.filePath.prefix + scope.viewModel.formModel.filePath.fileName;
                    }
                    templateData.userId = scope.templateAr2Service.userModel.userId ? scope.templateAr2Service.userModel.userId : 0;
                    scope.templateAr2Service.registerTemplate(templateData)
                        .then(function (res) {
                        scope.success();
                    }, function (err) {
                    });
                };
                scope.removeTemplate = function () {
                    if (!scope.viewModel.formModel.uploadedFile || !angular.isDefined(scope.viewModel.formModel.uploadedFile.alias)) {
                        return;
                    }
                    templateService.cancelUploadTemplateFile(scope.viewModel.formModel.uploadedFile.alias, true);
                };
                scope.closeUploadDialog = function () {
                    if (!scope.viewModel.formModel.uploadedFile) {
                        scope.cancel();
                        return;
                    }
                    scope.removeTemplate();
                    scope.cancel();
                };
                scope.editTemplateModelDialog = function () {
                    scope.templateAr2Service.previewEditTemplateDialog({
                        fileName: scope.viewModel.formModel.uploadedFile.alias,
                        type: scope.viewModel.formModel.type,
                        isOnlyPreview: true
                    });
                };
                scope.showError = function () {
                    var msg = scope.viewModel.error ? scope.viewModel.error : 'Some sort of unexpected error!';
                    dialogs.notify(scope.viewModel.errorMessage, msg);
                };
                scope.saveTemplateAsCustom = function () {
                    var templateData = angular.copy(scope.viewModel.formModel);
                    templateData.tmpFileName = scope.viewModel.formModel.uploadedFile.alias;
                    templateData.templateId = angular.isDefined(scope.template.templateId) ? parseInt(scope.template.templateId) : 0;
                    templateData.userId = scope.templateAr2Service.userModel.userId;
                    for (var i in scope.templateAr2Service.languages) {
                        if (scope.templateAr2Service.languages[i].languageId === templateData.languageId) {
                            templateData.languageName = scope.templateAr2Service.languages[i].languageName;
                            break;
                        }
                    }
                    delete templateData.uploadedFile;
                    templateData.file = scope.viewModel.formModel.filePath.prefix + scope.viewModel.formModel.filePath.fileName;
                    templateData.template = angular.copy(templateData);
                    scope.templateAr2Service.saveTemplateAsCustom(templateData)
                        .then(function () {
                        scope.success();
                    });
                };
                scope.clearUploadingModel = function () {
                    scope.viewModel.uploadingModel.fileLoadProgress = 0;
                    scope.viewModel.uploadingModel.isFileUploading = false;
                    scope.viewModel.uploadingModel.isFileUloaded = false;
                    scope.viewModel.uploadingModel.isUploadError = false;
                };
                //
            }
        };
    }]);
//# sourceMappingURL=templates-ar2-upload.directive.js.map